import { useState, useEffect } from 'react';
import Image from 'next/image';
import Price from '@/components/price/Price';
import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';

export default function BundleProductItem({ offer }) {
  const [currentOffer, setCurrentOffer] = useState(offer);
  useEffect(() => {
    setCurrentOffer(offer);
  }, [offer]);
  const { showModal } = useModal();

  const variantBundleDiscount = parseFloat(currentOffer.discount);

  // Update the savings message if needed
  let productSavingsMessage =
    currentOffer.settings.bundle_inventory_savings_message;
  if (productSavingsMessage?.includes('[amount]')) {
    productSavingsMessage = productSavingsMessage.replace(
      '[amount]',
      currentOffer.discount
    );
  }
  const handleShowInventoryModal = () => {
    showModal(MODAL_TYPES.inventory, {
      offer: currentOffer,
      variant: `bundles-${currentOffer.product.title}`
    });
  };
  return (
    <div className="mt-4 flex">
      <div className="bg-dawn-grey-20 relative mr-3 h-[48px] w-[64px]">
        <Image
          src={`${currentOffer?.variant?.image?.url}?format=pjpg&auto=webp&disable=upscale&crop=4:3`}
          width={64}
          height={48}
          alt={currentOffer?.variant?.title.replace(/\.[^/.]+$/, '')}
          style={{ objectFit: 'cover', width: '64px', height: '48px' }}
        />
      </div>
      <div>
        <button
          className="flex transition-opacity duration-300"
          onClick={handleShowInventoryModal}
        >
          <div className="body-s mb-2 text-white underline">
            {currentOffer.product.title}
          </div>
          <span className="mx-1 mt-1 h-4 w-4">
            <SvgInfo productTitle={currentOffer.product.title} />
          </span>
        </button>
        <div className="flex">
          {parseFloat(currentOffer.variant.price.amount) -
            variantBundleDiscount >
          0 ? (
            <Price
              price={
                parseFloat(currentOffer.variant.price.amount) -
                variantBundleDiscount
              }
              compareAtPrice={currentOffer.variant.compareAtPrice.amount}
              priceClassOverride="price-s text-orange!"
              crossedPriceClassOverride="price-s-crossed text-dawn-grey-60!"
            />
          ) : (
            <>
              <span className="sr-only">Sale price is</span>
              <ins className="price-s text-orange! mr-1 no-underline">FREE</ins>
              <span className="sr-only">Original price is</span>
              <del className="price-s-crossed text-dawn-grey-60! mr-1">
                ${parseFloat(currentOffer.variant.compareAtPrice.amount)}
              </del>
            </>
          )}
          {productSavingsMessage && (
            <div className="sh13 text-light-green ml-2 whitespace-nowrap">
              {productSavingsMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const SvgInfo = ({ productTitle }) => (
  <svg
    width="16px"
    height="16px"
    enableBackground="new 0 0 24 24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={`More Info about ${productTitle}`}
  >
    <path
      d="m11 11h1v5m-1.5 0h1.5m1.5 0h-1.5m0 5c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="11.9" cy="8.1" fill="#fff" r=".9" />
  </svg>
);
